import { numberRequiredSchema, select2RequiredSchema, stringRequiredSchema, stringSchema } from "utils/validation/validationHelpers";
import { object } from 'yup';

const schema = object().shape({
	date: stringRequiredSchema,
	assessment: object().required(),
});

export default schema;